<template>
  <v-row no-gutters>
    <!-- <v-col class="pa-2" cols="12" md="6">
          <div class="rowinfo">
            <v-text-field
              v-model="options.data"
              :readonly="readonly"
              append-icon="mdi-link-variant-plus"
              dense
              label="لینک"
              outlined
              class="contentinfo"
              placeholder="qr2.in"
              @input="$emit('update')"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-data-options`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="لینک"
            />
          </div>
        </v-col> -->

    <v-col class="pa-2" col="12" md="6">
      <div class="rowinfo">
        <v-text-field
          v-model="options.margin"
          dense
          label="حاشیه"
          min="0"
          outlined
          type="number"
          @input="updateSizes($event, 'margin')"
          class="contentinfo"
        />
        <help-info
          :element-name="`${serviceName}-${componentName}-margin-options`"
          :service-name="serviceName"
          :help-data="helpData"
          class="buttoninfo"
          label="حاشیه"
        />
      </div>
    </v-col>

    <v-col class="pa-2" col="12" md="6">
      <div class="rowinfo">
        <v-text-field
          v-model="options.width"
          dense
          label="عرض"
          min="0"
          outlined
          type="number"
          @input="updateSizes($event, 'width')"
          class="contentinfo"
        />
        <help-info
          :element-name="`${serviceName}-${componentName}-width-options`"
          :service-name="serviceName"
          :help-data="helpData"
          class="buttoninfo"
          label="عرض"
        />
      </div>
    </v-col>

    <v-col class="pa-2" col="12" md="6">
      <div class="rowinfo">
        <v-text-field
          v-model="options.height"
          dense
          label="ارتفاع"
          min="0"
          outlined
          type="number"
          @input="updateSizes($event, 'height')"
          class="contentinfo"
        />
        <help-info
          :element-name="`${serviceName}-${componentName}-height-options`"
          :service-name="serviceName"
          :help-data="helpData"
          class="buttoninfo"
          label="ارتفاع"
        />
      </div>
    </v-col>

    <v-col class="d-flex align-center grey--text" cols="12">
      رنگ پس زمینه
      <v-divider class="mx-2" />
    </v-col>

    <v-col cols="12" md="6">
      <v-switch v-model="bgSwitch" label="رنگ گرادینت" />
    </v-col>

    <template v-if="bgSwitch">
      <v-col class="pa-2" cols="12" md="6">
        <v-radio-group
          v-model="options.backgroundOptions.gradient.type"
          class="ma-0"
          row
          @change="$emit('update', true)"
        >
          <v-radio label="خطی" value="linear" />
          <v-radio label="دایره ای" value="radial" />
        </v-radio-group>
      </v-col>

      <v-col class="pa-2" cols="12">
        <v-slider
          v-model="computedRotation"
          append-icon="mdi-rotate-360"
          label="چرخش رنگ"
          max="360"
          min="0"
          thumb-label
          track-color="grey"
          @input="$emit('update', true)"
        >
          <template v-slot:thumb-label="{ value }">
            <div
              class="d-flex align-center justify-center"
              style="
                width: 20px;
                height: 20px;
                background-color: rgba(12, 15, 26, 0.7);
                border-radius: 50%;
              "
            >
              {{ value }}°
            </div>
          </template>
        </v-slider>
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <color-picker
          v-model="options.backgroundOptions.gradient.colorStops[0].color"
          label="رنگ اول"
          @input="$emit('update', true)"
        />
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <color-picker
          v-model="options.backgroundOptions.gradient.colorStops[1].color"
          label="رنگ دوم"
          @input="$emit('update', true)"
        />
      </v-col>
    </template>

    <v-col v-else class="pa-2" cols="12" md="6">
      <color-picker
        v-model="options.backgroundOptions.color"
        label="رنگ پس زمینه"
        @input="$emit('update', true)"
      />
    </v-col>
  </v-row>
</template>

<script>
import ColorPicker from "../colorPicker.vue";

export default {
  name: "qrCodeData",

  components: { ColorPicker },

  props: {
    value: Object,
    readonly: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "qrCodeData",
    bgSwitch: false,
    rotation: 0,
  }),

  computed: {
    options: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedRotation: {
      get() {
        return this.rotation;
      },
      set(val) {
        this.rotation = val;
        this.options.backgroundOptions.gradient.rotation =
          (val * Math.PI) / 180;
        this.$emit("update", true);
      },
    },
  },

  watch: {
    bgSwitch(val) {
      if (!val) this.options.backgroundOptions.gradient = null;
      else {
        this.options.backgroundOptions.gradient = {
          type: "linear",
          rotation: 0,
          colorStops: [
            {
              offset: 0,
              color: "#ffffffff",
            },
            {
              offset: 1,
              color: "#ffffffff",
            },
          ],
        };
      }
      this.$emit("update", true);
    },
  },

  methods: {
    updateSizes(e, field) {
      if (e < 0) this.options[field] = 0;
      this.$emit("update");
    },
  },
};
</script>

<style scoped></style>
